module.exports = function() {
  return new Worker(__webpack_public_path__ + "634c3bbe181adf51ed11.worker.js");
};